import cn from 'classnames'
import React from 'react'
import { typographyStyles } from '@grammarly/badger-ui'
import styles from './form.module.scss'

interface HelperTextProps {
  children?: React.ReactNode
  className?: string
  id?: string
}

export const HelperText: React.FC<HelperTextProps> = ({ children, className, id }) => {
  return (
    <div id={id} className={cn(typographyStyles.C5, styles.helperText, className)}>
      {children}
    </div>
  )
}
